// extracted by mini-css-extract-plugin
export default {"root":"P3j0Q","icon":"B8AdR","description":"iam9n","tablet":"RCBC_","backButton":"ji59b"};